import React, { forwardRef } from 'react';

import { Box } from '@mui/material';

import { sharedClasses } from '../CustomUIElements/sharedClasses';

import type { SxProps } from '@mui/material';

const BetaButton = forwardRef<HTMLElement, { sx?: SxProps }>(({ sx, ...props }, ref) => (
  <Box ref={ref} sx={{ ...sharedClasses.applicationBetaButton, ...sx }} {...props}>
    BETA
  </Box>
));
BetaButton.displayName = 'BetaButton';
export default BetaButton;
